// @view/panels/document/DocumentDetailsPromptPage.panel.tsx
import React from "react";
import EmptyView from "@view/EmptyView";
import DocumentDetailsPromptComponent from "@view/document/DocumentDetailsPrompt";
import type { DocumentDetailsPromptViewProps } from "@ps-bridge/contracts/documentDetailsPrompt";

export type DocumentDetailsPromptPagePhase = "missing" | "ready";

type DocumentDetailsPromptPagePanelProps = {
  phase: DocumentDetailsPromptPagePhase;
  viewProps: DocumentDetailsPromptViewProps;
};

const DocumentDetailsPromptPagePanel: React.FC<DocumentDetailsPromptPagePanelProps> = ({
  phase,
  viewProps,
}) => {
  const render = {
    missing: <EmptyView />,
    ready: <DocumentDetailsPromptComponent {...viewProps} />,
  } as const satisfies Record<DocumentDetailsPromptPagePhase, React.ReactElement>;

  return (
    <div
      data-testid="page-documentDetailsPrompt"
      data-page-state={phase === "ready" ? "ready" : "init"}
      data-page-phase={phase}
    >
      {render[phase]}
    </div>
  );
};

export default DocumentDetailsPromptPagePanel;
